// extracted by mini-css-extract-plugin
module.exports = {"loading":"ConfirmationInnerLoader-module__loading___b8BeE"};